// Route Traffic
(function (angular, app) {
   "use strict";

   angular.module(app.modules.app.name).config(appRouter);
   
   appRouter.$inject = ["$routeProvider"
   ];
   
   function preRoute(route) {
      route.resolve = {
         validate: function () {
            if (app.Member) {
               return app.Member.Session.pageTemplates.fetch(route.templateUrl).then(function (template) {
                  return app.Member.Authenticate.ValidateToken().then(function () {
                      return route;
                  });
               });
            }
         }
      }
      return route;
   }

   function appRouter($routeProvider) {
      $routeProvider.
      
      // Invalid
      when(app.modules.view.routes.invalid.path, preRoute(app.modules.view.routes.invalid)).
      when(app.modules.view.routes.accessdenied.path, preRoute(app.modules.view.routes.accessdenied)).
      
      // Intro // should only show this if not logged in.
      when(app.modules.view.routes.intro.path, preRoute(app.modules.view.routes.intro)).
      when(app.modules.view.routes.privacy.path, preRoute(app.modules.view.routes.privacy)).
      when(app.modules.view.routes.comingsoon.path, preRoute(app.modules.view.routes.comingsoon)).

      // Register
      when(app.modules.view.routes.register.path, preRoute(app.modules.view.routes.register)).
      
      // Member
      //when(app.modules.member.routes.home.path, preRoute(app.modules.member.routes.home)).
      when(app.modules.member.routes.profile.path, preRoute(app.modules.member.routes.profile)).
      when(app.modules.member.routes.timeline.path, preRoute(app.modules.member.routes.timeline)).
      when(app.modules.member.routes.scoring.path, preRoute(app.modules.member.routes.scoring)).
      when(app.modules.member.routes.handicaplookup.path, preRoute(app.modules.member.routes.handicaplookup)).
      when(app.modules.member.routes.outings.path, preRoute(app.modules.member.routes.outings)).
      when(app.modules.member.routes.memberdetail.path, preRoute(app.modules.member.routes.memberdetail)).
      
      // Invitation
      when(app.modules.invitation.routes.invited.path, preRoute(app.modules.invitation.routes.invited)).

      // Groups
      when(app.modules.group.routes.lookup.path, preRoute(app.modules.group.routes.lookup)).
      when(app.modules.group.routes.setup.path, preRoute(app.modules.group.routes.setup)).
      when(app.modules.group.routes.detail.path, preRoute(app.modules.group.routes.detail)).

      // Outings
      when(app.modules.outing.routes.setup.path, preRoute(app.modules.outing.routes.setup)).
      when(app.modules.outing.routes.detail.path, preRoute(app.modules.outing.routes.detail)).
      when(app.modules.outing.routes.leaderboard.path, preRoute(app.modules.outing.routes.leaderboard)).
      
      // Course
      when(app.modules.course.routes.search.path, preRoute(app.modules.course.routes.search)).
      
      // Post a Score
      when(app.modules.scoring.routes.postascore.path, preRoute(app.modules.scoring.routes.postascore)).
      when(app.modules.scoring.routes.postaround.path, preRoute(app.modules.scoring.routes.postaround)).
      when(app.modules.scoring.routes.scoredetail.path, preRoute(app.modules.scoring.routes.scoredetail)).

     
      // Back to Invalid
      otherwise({ redirectTo: app.modules.view.routes.invalid.path });
      
   }
   
}(angular, app)); 